import { render } from "./physiotherapy_prescriptions.vue?vue&type=template&id=6b673334&scoped=true"
import script from "./physiotherapy_prescriptions.vue?vue&type=script&lang=js"
export * from "./physiotherapy_prescriptions.vue?vue&type=script&lang=js"

import "./physiotherapy_prescriptions.vue?vue&type=style&index=0&id=6b673334&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b673334"]])

export default __exports__